export enum TubeListFormValue {
  DESCRIPTION = 'Description',
  NwtOnly = 'NwtOnly',
}
